import { lazy } from "react";
import { useParams } from "react-router";

import { LayoutType } from "../../types";

const PageLayout = lazy(() => import("../Layouts/PageLayout"));
const SidebarLayout = lazy(() => import("../Layouts/SidebarLayout"));

const Embedded = () => {
	const { id, layout } = useParams<{ id: string; layout: LayoutType }>();
	if (!id) {
		return null;
	}

	switch (layout) {
		case LayoutType.Sidebar:
			return <SidebarLayout />;
		case LayoutType.WebPage:
			return <PageLayout />;
		default:
			return null;
	}
};

export default Embedded;
